import React from 'react';
import { formatCurrency } from './PlanCard';
import { PackageUI } from '@/api/type';

type PlanStatus = 'open' | 'closed' | 'expired';
interface PlanListRowProps {
  plan: PackageUI;
  onViewDetail: (plan: PackageUI) => void;
}

const statusLabels: Record<PlanStatus, string> = {
  open: 'Đang mở',
  closed: 'Đã đóng',
  expired: 'Hết hạn',
};

const statusStyles: Record<PlanStatus, string> = {
  open: '!bg-green-500/10 !text-green-600 dark:!text-green-400',
  closed: '!bg-gray-500/10 !text-gray-600 dark:!text-gray-400',
  expired: '!bg-red-500/10 !text-red-600 dark:!text-red-400',
};

const statusDotStyles: Record<PlanStatus, string> = {
  open: '!bg-green-500',
  closed: '!bg-gray-500',
  expired: '!bg-red-500',
};

export const PlanListRow: React.FC<PlanListRowProps> = ({ plan, onViewDetail }) => {
  const isDisabled = plan.status !== 'open';

  return (
    <tr className="!border-b !border-gray-100 dark:!border-dark-border hover:!bg-gray-50 dark:hover:!bg-dark-card-elevated/50 !transition-colors">
      <td className="px-4 py-4">
        <div className="max-w-[280px]">
          <h4 className="!text-sm !font-semibold !text-gray-900 dark:!text-white mb-1">
            {plan.name}
          </h4>
          <p className="!text-xs !text-gray-500 dark:!text-dark-text/80 line-clamp-2">
            {plan.description}
          </p>
        </div>
      </td>

      <td className="px-4 py-4">
        <span className={`inline-flex items-center gap-1.5 !px-3 !py-1.5 !rounded-full !text-xs !font-medium ${statusStyles[plan.status as PlanStatus]}`}>
          <span className={`w-1.5 h-1.5 rounded-full ${statusDotStyles[plan.status as PlanStatus]}`} />
          {statusLabels[plan.status as PlanStatus]}
        </span>
      </td>

      <td className="px-4 py-4">
        <div>
          <p className="!text-sm !font-semibold !text-gray-900 dark:!text-white">
            {formatCurrency(plan.minInvestment)}
          </p>
        </div>
      </td>

      <td className="px-4 py-4 text-center">
        {
          plan.profitRate > 0 ? (
            <>
              <p className="!text-sm !text-status-success">
                {plan.profitRate}%
              </p>
              <p className="!text-xs !text-gray-400 dark:!text-dark-text-muted">
                /{plan.profitPeriod === 'month' ? 'tháng' : 'năm'}
              </p>
            </>
          ) : (
            <p className="!text-xs !text-gray-700 dark:!text-dark-text-secondary">
              Theo doanh thu
            </p>
          )
        }
      </td>

      <td className="px-4 py-4 text-center">
        <p className="!text-sm !text-gray-900 dark:!text-white">
          {plan.duration == 0 ? <p className='!text-xs !text-gray-900 dark:!text-white'>Đến khi hủy</p> : plan.duration}
        </p>
        {
          plan.duration > 0 && (
            <p className="!text-xs !text-gray-400 dark:!text-dark-text-muted">tháng</p>
          )
        }
      </td>

      <td className="px-4 py-4 text-center">
        <p className="!text-sm !text-gray-700 dark:!text-dark-text-secondary">
          <span className="!font-semibold !text-status-success">{plan.commissionF1}%</span>
        </p>
      </td>

      <td className="px-4 py-4 text-center">
        <p className="!text-sm !text-gray-700 dark:!text-dark-text">
          {plan.maxSlot}
        </p>
      </td>

      <td className="px-4 py-4 text-center">
        <button
          onClick={() => onViewDetail(plan)}
          disabled={isDisabled}
          className={`!px-4 !py-2 !rounded-md !text-sm !font-medium !transition-colors !border-none whitespace-nowrap ${isDisabled
            ? '!bg-gray-200 dark:!bg-dark-border !text-gray-400 dark:!text-dark-text-muted cursor-not-allowed'
            : '!bg-primary hover:!bg-primary-dark !text-white'
            }`}
        >
          {isDisabled ? 'Đã đóng' : 'Chi tiết'}
        </button>
      </td>
    </tr>
  );
};
